import { currencyShotern } from 'common/utility';
import { formatStringToDisplay } from '../../../common/helper';
import { isEmpty } from 'lodash';
import moment from 'moment';
import React from 'react'
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap'
import NoDataComponent from '../NoDataComponent';
const EntityBorrowingProfile = ({borrowingProfileData}) => {


    let borrowProfileDate = '';
    let borrowingProfileList = [];
    if (!isEmpty(borrowingProfileData) && !isEmpty(borrowingProfileData.borrowingAsOf)) {
      borrowProfileDate = moment(borrowingProfileData.borrowingAsOf).format('MMM DD, YYYY')
    }

    if (!isEmpty(borrowingProfileData) && !isEmpty(borrowingProfileData.lenderList)) {
      borrowingProfileList = borrowingProfileData.lenderList
    }


    return (
        <React.Fragment>
            <Card style={{border:"none"}}>
                <CardHeader>
                    <div className="d-flex align-items-end">
                        <h4>Borrowing Profile(s)</h4><h6 className="text-muted ms-2">{!isEmpty(borrowProfileDate) ? `as of ${borrowProfileDate}` : ''}</h6>
                    </div>
                </CardHeader>
                <CardBody className='m-0 p-0'>
                    <Row>

                        {!isEmpty(borrowingProfileList) ? borrowingProfileList.map((item, index) => {
                            return (
                                <>
                                <Col sm={4} className=''>
                                    <div className='d-flex flex-column align-items-center py-5 border'>
                                        <h3>{currencyShotern(item.sanctionedAmount)}</h3>
                                        {/* <h4 className="text-muted">{item.lenderName}</h4> */}
                                        <h5 className="text-muted">{formatStringToDisplay(item.type, '_')} {" "}</h5>
                                    </div>
                                    </Col>
                                </>
                            )
                        }): <Col sm={12} className=''>
                        <NoDataComponent title='No Data' subtitle='No Data Available' />
                     </Col>}
                            </Row>
                </CardBody>
            </Card>
        </React.Fragment>
    )
}

export default EntityBorrowingProfile